import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';

export default function CollegeLoacations() {
    const userid = (sessionStorage.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');
    const locationFormik = useFormik({
        initialValues: {

        },
        onSubmit: (values) => {
            console.log("Values", values)
        }
    })

    const [location, setLocation] = useState([]);
    function GetFeeData() {
        let url = config.url.API_URL + "geoLocationDetails/" + userid;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setLocation(res?.data?.geoLocationDetails)


            } else {
                setLocation([])

            }
        })
    }
    useEffect(() => {
        GetFeeData();
    }, [])
    return (
        <>

            <CommonFormHeading heading="College Location" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">

                    <FormikProvider value={locationFormik}>
                        <Form onChange={locationFormik?.handleChange} onSubmit={locationFormik?.handleSubmit} className='affl-form'>
                            <center> <b style={{ color: "brown", fontSize: "20px", fontFamily: "unset" }}> College Inspection Verification Type : &emsp;{location[0]?.verification_type === "Physical_Verification" ? "Physical Verification" : "Virtual Verification"} </b></center>
                            <br />

                            {location[0]?.verification_type === "Physical_Verification" && (<>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="">College Geo-Location</h1>
                                </div>
                                <bie.Row className="px-2 pt-3 mb-3">
                                    <bie.Row>
                                        <bie.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9}>

                                            Collge Name: &emsp;      {location[0]?.inst_name}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>

                                            College Code:  &emsp;     {location[0]?.coll_code}
                                        </bie.Col>

                                    </bie.Row>
                                    <br />
                                    <br />


                                    <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                        <thead>
                                            <tr>
                                                <th>Latitude</th>
                                                <th>Longitude</th>
                                                <th>Location Name</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>

                                                <td>{location[0]?.latitude ?? '-'}</td>
                                                <td>{location[0]?.longitude ?? '-'}</td>
                                                <td className="text-left"> {location[0]?.inst_name} &emsp;- &emsp;{location[0]?.lat_long_name ?? '-'}</td>

                                            </tr>
                                        </tbody>
                                    </table>



                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="">College FFCA Geo-Location</h1>
                                    </div>


                                    <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                        <thead>
                                            <tr>
                                                <th>Latitude</th>
                                                <th>Longitude</th>
                                                <th>Location Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{location[0]?.ffcalatitude ?? '-'}</td>
                                                <td>{location[0]?.ffcalongitude ?? '-'}</td>
                                                <td className="text-left"> {location[0]?.inst_name} &emsp;- &emsp;{location[0]?.ffcalatlong_desc ?? '-'}</td>

                                            </tr>


                                        </tbody>
                                    </table>
                                </bie.Row>
                            </>)}
                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container >

        </>
    )
}
